import React from "react";

const Bemerkung = ({note, by, at, isSystem}) => {
    return (
        <div className={`${!note && 'hidden'} box-content rounded-lg px-4 `}>
            <div className='lg:flex justify-between bg-white mt-5'>
                <h2 className='ml-1'>
                    <span className='text-sm text-grey'>
                        {(new Date(at).toLocaleString([], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })).replaceAll('/', '.')},
                        <span className='text-sm lg:text-left text-text font-extrabold ml-1'>{by?by:'No User'}</span>
                    </span>
                </h2>
            </div>
            <p
                className={`p-2 text-left text-sm rounded-md ${
                    isSystem
                        ? 'bg-silver border border-silver'
                        : 'bg-yellowLight'
                }`}
                dangerouslySetInnerHTML={{ __html: note }}
            />
        </div>
    )
}

export default Bemerkung
